import { $, $$, htmlDecode } from 'utils/dom';

class EventDetail {
  MAX_FUTURE_INDICES = 4;

  constructor() {
    this.indicesContainer = $('.ems-other-indices');
    this.indicesLabel = $('.ems-other-indices-label');
    this.otherIndexItems = $$('.ems-other-index');
  }

  init() {
    if (this.indicesContainer) {
      this.updateIndex();
      // stop twebshop widget from interfering with the url hash
      window.addEventListener(
        'popstate',
        event => event.stopImmediatePropagation(),
        true
      );
      window.addEventListener('hashchange', this.updateIndex.bind(this));
      this.initOtherIndexItemsLinkHandler();
    }
  }

  updateIndex() {
    const indexItem =
      this.getIndexItemFromLocationHash() ?? this.getNextIndexItem();
    if (indexItem) {
      this.replaceDateText(indexItem);
      this.showOtherFutureIndices(indexItem);
    }
  }

  getIndexItemFromLocationHash() {
    const dateFromURL = window.location.hash.substring(1);
    return this.otherIndexItems.find(
      indexItem => indexItem.dataset.start === dateFromURL
    );
  }

  getNextIndexItem() {
    const now = new Date();
    return this.otherIndexItems.find(
      indexItem => new Date(indexItem.dataset.start) > now
    );
  }

  replaceDateText(indexItem) {
    const eventDateTarget = $('[data-date-text-target]');
    if (eventDateTarget && indexItem.dataset.dateText !== undefined) {
      eventDateTarget.innerHTML = htmlDecode(indexItem.dataset.dateText);
    }
  }

  showOtherFutureIndices(currentIndexItem) {
    let count = 0;
    this.otherIndexItems.forEach(indexItem => {
      const indexDate = new Date(indexItem.dataset.start);
      if (
        count < this.MAX_FUTURE_INDICES &&
        currentIndexItem !== indexItem &&
        indexDate.getTime() > Date.now()
      ) {
        indexItem.hidden = false;
        ++count;
      } else {
        indexItem.hidden = true;
      }
    });
    const isEveryIndexHidden = this.otherIndexItems.every(
      indexItem => indexItem.hidden
    );
    this.indicesContainer.hidden = isEveryIndexHidden;
    this.indicesLabel.hidden = isEveryIndexHidden;
  }

  initOtherIndexItemsLinkHandler() {
    $$('.ems-other-index a[href^="#"]').forEach(link => {
      link.addEventListener('click', () => {
        window.scrollTo(0, 0);
      });
    });
  }
}

new EventDetail().init();
